import { render } from "./PopupImage.vue?vue&type=template&id=1b98ea14&scoped=true"
import script from "./PopupImage.vue?vue&type=script&lang=js"
export * from "./PopupImage.vue?vue&type=script&lang=js"

import "./PopupImage.vue?vue&type=style&index=0&id=1b98ea14&scoped=true&lang=scss"
import "./PopupImage.vue?vue&type=style&index=1&id=1b98ea14&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b98ea14"]])

export default __exports__